import React from 'react'

interface SelectionCardProps {
  icon: React.ReactNode
  title: string
  description?: string
  selected: boolean
  onClick: () => void
}

const SelectionCard = ({ icon, title, description, selected, onClick }: SelectionCardProps) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      padding: '24px 16px',
      borderRadius: '12px',
      border: `2px solid ${selected ? '#2196F3' : '#e5e7eb'}`,
      backgroundColor: selected ? '#EFF6FF' : '#fff',
      cursor: 'pointer',
      textAlign: 'center',
      transition: 'border-color 0.15s, background-color 0.15s',
    }}
  >
    <span style={{ color: selected ? '#2196F3' : '#6b7280', lineHeight: 0 }}>
      {icon}
    </span>
    <p style={{ margin: 0, fontSize: '0.875rem', fontWeight: 500, color: selected ? '#2196F3' : '#374151' }}>
      {title}
    </p>
    {description && (
      <p style={{ margin: 0, fontSize: '0.75rem', color: '#9ca3af', lineHeight: 1.4 }}>
        {description}
      </p>
    )}
  </button>
)

export default SelectionCard
